module.exports = __webpack_public_path__ + "src/assets/img/videoplatform.098241bc.jpg";